export function parseLanguageFromLocale(locale: string): string {
  const regex = /^[a-z]{2}/i;
  const match = locale.match(regex);

  if (!match) {
    throw new Error(`Unable to parse language from locale: '${locale}'.`);
  }

  return match[0].toLowerCase();
}
